import { useInfiniteQuery } from '@tanstack/react-query';
import { FancySharesRequestDto, FancySharesResponseDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { FancyShareApi } from 'api/ApiHelper';
import { fancyShareQueryKey } from 'queries/fancyShare/queryKey';

const DEFAULT_LIMIT = 5;

const getNextPageParam = (lastGroup: FancySharesResponseDto, allGroups: FancySharesResponseDto[]) => {
  if ((lastGroup.fancyShares?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.fancyShares.length, 0);
};

export const useGetFancySharesInfiniteQuery = (data: FancySharesRequestDto) =>
  useInfiniteQuery({
    queryKey: fancyShareQueryKey.fancyShareList(data),
    queryFn: ({ pageParam = 0 }) => FancyShareApi.findByIncludeAdult(data, { offset: pageParam, limit: DEFAULT_LIMIT }),
    initialPageParam: 0,
    getNextPageParam,
  });
